(function (app, ng) {

    var accountStatusStructure = {
        StatusDate: "date"
    };

    function datify(obj, structure) {
        if (!obj) return;
        if (ng.isArray(structure)) {
            for (var i = 0; i < obj.length; i++) {
                if (structure[0] === "date" && ng.isString(obj[i]))
                    obj[i] = new Date(obj[i]);
                if (ng.isObject(structure[0]) || ng.isArray(structure[0]))
                    datify(obj[i], structure[0]);
            }
            return;
        }
        if (ng.isObject(structure)) {
            for (var key in structure) {
                if (!structure.hasOwnProperty(key)) continue;
                if (structure[key] === "date" && ng.isString(obj[key]))
                    obj[key] = new Date(obj[key]);
                if (ng.isObject(structure[key]) || ng.isArray(structure[key]))
                    datify(obj[key], structure[key]);
            }
        }
    }
    app.provider("accountStatusApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        const service = {};

                        //GETs
                        service.getAccountStatus = (accountStatusId) => {
                            return crmApiGateway.get(`/AccountStatuses/${accountStatusId}`).then(status => {
                                datify(status, accountStatusStructure);
                                return status;
                            });
                        };

                        service.getInvestmentAccountStatuses = (accountId) => {
                            return crmApiGateway.getArray(`/InvestmentAccounts/${accountId}/AccountStatuses`).then(
                                statuses => {
                                    datify(statuses, [accountStatusStructure]);
                                    return statuses;
                                });
                        };

                        service.getInsuranceAccountStatuses = (accountId) => {
                            return crmApiGateway.getArray(`/InsuranceAccounts/${accountId}/AccountStatuses`).then(
                                statuses => {
                                    datify(statuses, [accountStatusStructure]);
                                    return statuses;
                                });
                        };

                        //PUTs
                        service.updateAccountStatus = (accountStatusId, accountStatus) => {
                            return crmApiGateway.put(`/AccountStatuses/${accountStatusId}`, accountStatus);
                        };

                        //POSTs
                        service.createAccountStatus = (accountStatus) => {
                            return crmApiGateway.post("/AccountStatuses", accountStatus);
                        };

                        //DELETE
                        service.deleteAccountStatus = (accountStatusId) => {
                            return crmApiGateway.delete(`/AccountStatuses/${accountStatusId}`);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app, window.angular); //jshint ignore:line